import { MdOutlineDocumentScanner, MdOutlineSummarize } from 'react-icons/md';
import { PiSealPercentBold } from "react-icons/pi";
import { RiHome2Line } from "react-icons/ri";
import { LiaCoinsSolid } from "react-icons/lia";


export const sidebarConf = [
    {
        "pageName": "dashboard",
        "path": "/",
        "label": "Dashboard",
        "icon": <RiHome2Line className="icon" />
    },
    {
        "pageName": "f24-extraction",
        "path": "/f24-extraction",
        "label": "Estrazione F24",
        "icon": <MdOutlineDocumentScanner className="icon" />
    },
    {
        "pageName": "marelli-registri-iva",
        "path": "/marelli-registri-iva",
        "label": "Registri IVA Marelli",
        "icon": <PiSealPercentBold className="icon" />
    },
    {
        "pageName": "dm10-reading",
        "path": "/dm10-reading",
        "label": "Lettura DM10",
        "icon": <LiaCoinsSolid className="icon" />
    },
    {
        "pageName": "f24-summarize",
        "path": "/f24-summarize",
        "label": "Riepilogo F24",
        "icon": <MdOutlineSummarize className="icon" />
    }
];
